export const VERY_DENSE = 0.95
export const DENSE = 0.89
export const MEDIUM = 0.62
export const LOW = 0.5
export const SUPER_LOW = 0.3

export function high(d) {
  return d >= VERY_DENSE
}

export function mediumHigh(d) {
  return d >= DENSE && d < VERY_DENSE
}

export function medium(d) {
  return d >= MEDIUM && d < DENSE
}

export function low(d) {
  return d >= LOW && d < MEDIUM
}

export function superLow(d) {
  return d < LOW
}

export function densityToString(d) {
  return high(d)
    ? 'High'
    : mediumHigh(d)
    ? 'Medium High'
    : medium(d)
    ? 'Medium'
    : low(d)
    ? 'Low'
    : d === null
    ? null
    : 'Super Low'
}
